import React, { useState } from 'react'

import classNames from 'classnames'

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name?: string
  min: number
  max: number
  step: number
  value: number
  onChange?: (number) => void
}

const Slider: React.FC<Props> = ({ name, min, max, value, step, onChange, className }: Props) => {
  const [val, setVal] = useState(value)

  const update = (e: React.FormEvent<HTMLInputElement>) => {
    const v = Number(e.currentTarget.value)
    setVal(v)
    if (onChange) onChange(v)
  }

  return (
    <input
      type="range"
      name={name}
      className={classNames('pl-1 slider', className)}
      onChange={update}
      step={step}
      min={min}
      max={max}
      value={val}
    />
  )
}

export default Slider
